<template lang="pug">
.button-icon-text(@click='clickEvent')
  button-base.button-icon-text__icon(:data-icon-color='iconColor')
    image-base.button-icon-text__icon__img(:src='require(`@/assets/img/common/icon/${type}.svg`)')
  .button-icon-text__text.font-medium(v-if='isExistSlot')
    slot
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'

/**
 * アイコン・テキスト付きボタン
 */
@Component({
  components: {
    ButtonBase,
    ImageBase,
  },
})
export default class ButtonIconText extends Vue {
  /**
   * ボタン種別
   * + NOTE: 使用するアイコンファイル名【 assets/img/common/icon/${type}.svg 】と一致させる
   */
  @Prop()
  type!: 'remove' | 'download' | 'upload' | 'edit' | 'qr' | 'pdf' | 'update'

  /** アイコン背景色 */
  @Prop({ default: 'default' })
  iconColor!: 'default' | 'red' | 'transparent'

  /**
   * Slot存在判定
   * + NOTE: Slot内容をボタンテキストとして表示する
   */
  private get isExistSlot(): boolean {
    return !!this.$scopedSlots.default
  }

  /** クリック時イベント */
  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.button-icon-text
  display flex
  flex-direction row
  align-items center
  justify-content flex-start
  border-radius 10px
  padding 8px 10px
  gap 15px
  width 132px
  height 48px
  overflow hidden
  cursor pointer

  &:hover
    background-color var(--color-input-manager-icon-text__hover)

  &__icon
    display flex
    align-items center
    justify-content center
    border-radius 50%
    width 32px
    height 32px

    &__img
      display flex
      align-items center
      justify-content center

    &[data-icon-color='default']
      background-color var(--color-input-manager-icon-text__background-default)
    &[data-icon-color='red']
      background-color var(--color-input-manager-icon-text__background-red)
    &[data-icon-color='transparent']
      background-color transparent

  &__text
    font-size 12px
    word-break keep-all
    color var(--color-input-manager-icon-text__description-text)
</style>
